import { useState } from "react";
import { tiposAreaVerde, statusArea, gruposUC, categoriasUC, statusGestaoUC } from "@/mocks/ambiental";

interface EnvironmentalFiltersProps {
  tab: "areas-verdes" | "ucs" | "apps" | "recuperacao";
  onFilter: (filters: Record<string, string>) => void;
}

export default function EnvironmentalFilters({ tab, onFilter }: EnvironmentalFiltersProps) {
  const [search, setSearch] = useState("");
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [bairro, setBairro] = useState("");
  const [categoria, setCategoria] = useState("");
  const [grupo, setGrupo] = useState("");
  const [statusGestao, setStatusGestao] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const applyFilters = () => {
    const f: Record<string, string> = {};
    if (search) f.search = search.toLowerCase();
    if (tipo) f.tipo = tipo;
    if (status) f.status = status;
    if (bairro) f.bairro = bairro.toLowerCase();
    if (categoria) f.categoria = categoria;
    if (grupo) f.grupo = grupo;
    if (statusGestao) f.statusGestao = statusGestao;
    onFilter(f);
  };

  const clearFilters = () => {
    setSearch("");
    setTipo("");
    setStatus("");
    setBairro("");
    setCategoria("");
    setGrupo("");
    setStatusGestao("");
    onFilter({});
  };

  const hasFilters = search || tipo || status || bairro || categoria || grupo || statusGestao;
  const filterCount = [search, tipo, status, bairro, categoria, grupo, statusGestao].filter(Boolean).length;

  const isUC = tab === "ucs";

  return (
    <div className="bg-white rounded-card border border-background-200 p-4">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex-1 min-w-[200px] relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            placeholder={isUC ? "Buscar por nome, código ou órgão gestor..." : "Buscar por nome, bairro ou responsável..."}
            value={search}
            onChange={(e) => { setSearch(e.target.value); }}
            onKeyDown={(e) => { if (e.key === "Enter") applyFilters(); }}
            className="w-full pl-9 pr-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 bg-background-50"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-outline text-xs px-3 py-2 cursor-pointer ${showFilters ? "border-primary-400 text-primary-600 bg-primary-50" : ""}`}
        >
          <i className="ri-filter-3-line"></i>
          Filtros
          {filterCount > 0 && (
            <span className="ml-1 w-4 h-4 rounded-full bg-primary-500 text-white text-[10px] flex items-center justify-center">
              {filterCount}
            </span>
          )}
        </button>
        {hasFilters && (
          <button onClick={clearFilters} className="btn-outline text-xs px-3 py-2 cursor-pointer">
            <i className="ri-close-line"></i>
            Limpar
          </button>
        )}
      </div>

      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3 pt-3 border-t border-background-200">
          {isUC ? (
            <>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Categoria</label>
                <select value={categoria} onChange={(e) => setCategoria(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                  <option value="">Todas</option>
                  {categoriasUC.map((c) => (<option key={c} value={c}>{c}</option>))}
                </select>
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Grupo</label>
                <select value={grupo} onChange={(e) => setGrupo(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                  <option value="">Todos</option>
                  {gruposUC.map((g) => (<option key={g} value={g}>{g}</option>))}
                </select>
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Status de Gestão</label>
                <select value={statusGestao} onChange={(e) => setStatusGestao(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                  <option value="">Todos</option>
                  {statusGestaoUC.map((s) => (<option key={s} value={s}>{s}</option>))}
                </select>
              </div>
            </>
          ) : (
            <>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Tipo de Área</label>
                <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                  <option value="">Todos</option>
                  {tiposAreaVerde.map((t) => (<option key={t} value={t}>{t}</option>))}
                </select>
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Status</label>
                <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                  <option value="">Todos</option>
                  {statusArea.map((s) => (<option key={s} value={s}>{s}</option>))}
                </select>
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1 block">Bairro</label>
                <input
                  type="text"
                  placeholder="Ex: Setor Bueno"
                  value={bairro}
                  onChange={(e) => setBairro(e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50"
                />
              </div>
            </>
          )}
          <div className={isUC ? "col-span-full" : ""}>
            <button onClick={applyFilters} className="btn-primary text-xs px-4 py-2 cursor-pointer mt-5 w-full sm:w-auto">
              <i className="ri-check-line"></i>
              Aplicar Filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
}